module.exports = "/_next/static/resources/art-5c99c20a24a446284a8aa58c5ae788dd.webp";